import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { NavLink, useParams } from 'react-router-dom';

import Divider from 'flow/components/ui-components/Divider';
import useAppContext from 'flow/hooks/useAppContext';
import { selectDashboards } from 'flow/selectors/DashboardsSelectors';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';

import { generatePath } from 'flow/utils/router-utils';
import DashboardListItem from './DashboardListItem';

const DashboardsOverview = () => {
    const { i18next } = useAppContext();
    const { extensionKey } = useParams<{ extensionKey: ExtensionKey }>();
    const dashboards = useAppSelector(selectDashboards);

    return (
        <div className="mx-4">
            {dashboards
                .map((wallboard) => (
                    <div key={wallboard.get('key')} className="mb-6">
                        <DashboardListItem
                            dashboardKey={wallboard.get('key')}
                            extensionKey={extensionKey}
                        />
                    </div>
                ))
                .valueSeq()
                .toArray()}

            <Divider className="mb-5" />

            <NavLink
                to={generatePath(
                    routes['settings.dashboards.create.templates-picker'],
                    { extensionKey },
                )}
                className="flex items-center gap-3"
            >
                <div className="flex h-11 w-20 items-center justify-center rounded-xs border border-solid hover:bg-gray-200">
                    <div className="flex items-center justify-center text-[2rem] font-light text-gray-500">
                        {'+'}
                    </div>
                </div>
                <span className="text-sm font-bold">
                    {i18next.t('wallboard.create_new')}
                </span>
            </NavLink>
        </div>
    );
};

export default DashboardsOverview;
